import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiUrl, IrisApiClient } from '@iris/api-query';
import { IrisDmsSettingsI } from '@iris/common/modules/dms/models/IrisDmsSettings';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
@ApiUrl('/dms2/{iris@instanceId}/settings')
export class IrisDmsPropertiesService extends IrisApiClient<IrisDmsSettingsI>{
  protected readonly httpClient: HttpClient;

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  
    this.httpClient = httpClient;
  }

  getProperties(): Observable<IrisDmsSettingsI> {
    return this.getCore();
  }

  updateProperties(settings: IrisDmsSettingsI): Observable<IrisDmsSettingsI> {
    return this.saveCore(settings);
  }
}
